<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/users/table">用户列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel>
      <span slot="header">批量标签删除操作</span>
      <user-batch-tag-form displayName="批量删除标签"
                           @submit="onSubmit"></user-batch-tag-form>
    </layout-panel>
  </div>
</template>

<script>
import UserBatchTagForm from '../components/UserBatchTagForm'

export default {
  components: {UserBatchTagForm},
  data () {
    return {
      displayName: '批量添加标签',
    }
  },
  computed: {},
  watch: {},
  beforeRouteEnter (to, from, next) {
    next(vm => vm.onLoad())
  },
  beforeRouteUpdate (to, from, next) {
    this.onReload()
    next()
  },
  created () {},
  mounted () {},
  methods: {
    onLoad () {
    },
    onReload () {
      Object.assign(this.$data, this.$options.data())
      this.onLoad()
    },
    setForm (id) {
    },
    onSubmit (form) {
      request.common('delUserBatchTag', form).then((res) => {
        this.$confirm('批量删除标签成功', '提示', {type: 'success'}).then(() => {
        }, () => {
          this.$router.push({path: '/users/table'})
        })
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/user-batch-tag/pages/UserBatchDelTagForm.vue